import React, { useEffect } from 'react'
import { useTable } from 'react-table'

import '../../../globals/scss/components/tableview.scss'

function Table(props) {
  const {
    title,
    columns,
    data,
    disableSorting,
    getRowProps = () => ({}),
    getFooterProps = () => ({}),
    updateMyData = () => ({}),
    showFooter,
  } = props

  const { getTableProps, getTableBodyProps, headerGroups, footerGroups, rows, prepareRow, state } =
    useTable({
      columns,
      data,
      updateMyData,
      showFooter,
    })

  let myPageRows = rows

  return (
    <>
      <section className="tableGroup">
        <h3 {...getTableBodyProps()} className="tableTitle">
          {title}
          {myPageRows.length > 1 ? ' (' + myPageRows.length + ')' : null}
        </h3>
        <div className="scrollable -stickyFooter">
          <table className="-striped -highlight" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {myPageRows.length > 0 &&
                myPageRows.map(
                  (row, i) =>
                    prepareRow(row) || (
                      <tr {...row.getRowProps(getRowProps(row))}>
                        {row.cells.map((cell) => {
                          return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                        })}
                      </tr>
                    ),
                )}
            </tbody>
            {showFooter ? (
              <tfoot>
                {footerGroups.map((group) => (
                  <tr {...group.getFooterGroupProps()}>
                    {group.headers.map((column) =>
                      column.id !== 'jobName' ? (
                        <td className="-bold" {...column.getFooterProps(getFooterProps(column))}>
                          {column.render('Footer')}
                        </td>
                      ) : null,
                    )}
                  </tr>
                ))}
              </tfoot>
            ) : null}
          </table>
        </div>
      </section>
    </>
  )
}

export default function TableView(props) {
  const { title, columns, data, getRowProps, getFooterProps, updateMyData, showFooter } = props

  return (
    <Table
      title={title}
      columns={columns}
      data={data}
      getRowProps={getRowProps}
      getFooterProps={getFooterProps}
      updateMyData={updateMyData}
      showFooter={showFooter}
    />
  )
}
